import React from 'react';
import { withTranslation } from 'react-i18next';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad';
// material ui
import { ChatOutlined } from '@mui/icons-material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles({
    mainDiv:{
        width:'100%',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        borderRadius:'5px',
        backgroundColor:'#fff',
        padding:'40px 0px 0px 0px',
        marginBottom:'30px',
        boxShadow:'0px 1px 2px #00000038',
    },

    avatarDiv:props => ({
        width:'120px',
        height:'120px',
        borderRadius:'50%',
        backgroundColor: props.backgroundColor ? props.backgroundColor : '#0F467A',
        '& img':{
            width:'100%',
            height:'100%',
            borderRadius:'50%'
        }
    }),

    companyName:props => ({
        fontSize:'20px',
        color: props.fontDarkColor ? props.fontDarkColor : '#0F467A',
        fontWeight:'bold',
        textTransform:'capitalize',
        textAlign:'center',
        padding: '10px 0px 5px 0px',
        maxWidth: '90%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }),

    compType:{
        color:'#000000',
        fontSize:'15px',
        textAlign:'center',
        textTransform:'capitalize',
        fontWeight:'bold',
        paddingBottom: '10px',
    },
    
    chatNowBtn:props=> ({
        width:'100%',
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'center',
        padding:'15px 0px',
        border:'none',
        outline:'none',
        backgroundImage: props.mainColor ? `linear-gradient(265deg, ${props.mainColor} 0%, ${props.mainColor} 100%)` : 'linear-gradient(265deg, #49ceff 0%, #00185a 100%)',
        borderBottomLeftRadius:'5px',
        borderBottomRightRadius:'5px',
        '& svg':{
            color: props.fontLightColor ? props.fontLightColor : '#fff'
        },
        '& span':{
            fontSize:'20px',
            fontWeight:'bold',
            color: props.fontLightColor ? props.fontLightColor : '#fff'
        }
    }),

    marRight:{
        marginRight:'10px',
    },
    marLeft:{
        marginLeft:'10px',
    }
})

function LogoSection(props) {
    const { t, i18n, companyName, avatar, companyType, chatEvent,mainColor,backgroundColor,fontDarkColor,fontLightColor } = props;
    const classes = useStyles({mainColor,backgroundColor,fontDarkColor,fontLightColor});
    const isRTL = i18n.translator.language;
    const ar = "'Cairo', sans-serif";
    const en = "'Poppins', sans-serif";
    const fontFamily = isRTL === 'ar' ? ar : en;
    
    return(
        <div className={classes.mainDiv}>
            <div className={classes.avatarDiv}>
                <ImgLazyLoad>
                    <img src={avatar ? avatar : ''} alt='company' />
                </ImgLazyLoad>
            </div>
            <span className={classes.companyName} style={{fontFamily:"'Cairo', sans-serif"}}>{companyName ? companyName : '---'}</span>
            <span className={classes.compType} style={{fontFamily}}>{companyType ? companyType : '---'}</span>
            <button type='button' className={classes.chatNowBtn} onClick={chatEvent}>
                <ChatOutlined />
                <span style={{fontFamily}} className={isRTL === 'ar' ? classes.marRight : classes.marLeft}>{t('companyPage.chatnow')}</span>
            </button>
        </div>
    )
}

export default withTranslation('common')(LogoSection);